module.exports = __webpack_public_path__ + "static/media/banner_CallbreakQuick-half.73848bbc.png";